// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job-description__button{width:166px;height:38px;border-radius:25px;align-items:center;justify-content:center;cursor:pointer;text-transform:uppercase}.job-description__button--apply{background-color:#00a0dd}.job-description__button--share{color:#00a0dd;border:1px solid #00a0dd}", ""]);
// Exports
module.exports = exports;
